export default __webpack_public_path__ + "static/Mask-70d0c4de793533a40f9d0a17211ba01b.png";